var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-button add-sheet"},[_c('button',{staticClass:"item-center"},[_c('v-icon',[_vm._v("add_circle_outline")]),_vm._v(_vm._s(_vm.title)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }